import type { InvoiceStatus } from "@nlc/shared-types";

import { Badge } from "@/components/badge";

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  const isPaid = status === "paid";

  return (
    <Badge
      className="inline-flex justify-center whitespace-nowrap"
      isRounded
      size="small"
      variant={isPaid ? "success" : "error"}
    >
      {isPaid ? "Paid" : "Overdue"}
    </Badge>
  );
}
